import { render, staticRenderFns } from "./Get_prize_modal.vue?vue&type=template&id=77781980"
import script from "./Get_prize_modal.vue?vue&type=script&lang=js"
export * from "./Get_prize_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports